// extracted by mini-css-extract-plugin
export var cost = "style-module--cost--0488f";
export var cost__block = "style-module--cost__block--1e006";
export var cost__blockButton = "style-module--cost__block-button--43b4a";
export var cost__blockBuy = "style-module--cost__block-buy--c2bb2";
export var cost__blockContent = "style-module--cost__block-content--b41db";
export var cost__blockInstallment = "style-module--cost__block-installment--a279b";
export var cost__blockOnceTime = "style-module--cost__block-once-time--6685c";
export var cost__blockPrice = "style-module--cost__block-price--db1e4";
export var cost__blockUndertext = "style-module--cost__block-undertext--48fd7";
export var cost__blocks = "style-module--cost__blocks--7eb38";